import { useEffect, useState } from 'react';
import { APP_REF, APP_VERSION } from '@/app/version';
import styles from './LastRefreshed.module.css';

function formatRelative(iso: string): string {
  const diffMs = Date.now() - new Date(iso).getTime();
  const min = Math.round(diffMs / 60_000);
  if (min < 1) return 'just now';
  if (min < 60) return `${min} min ago`;
  const hours = Math.round(min / 60);
  if (hours < 24) return `${hours} h ago`;
  const days = Math.round(hours / 24);
  return `${days} d ago`;
}

const absFmt = new Intl.DateTimeFormat('en-GB', {
  year: 'numeric',
  month: 'short',
  day: '2-digit',
  hour: '2-digit',
  minute: '2-digit',
  timeZoneName: 'short',
});

export function LastRefreshed({ at }: { at: string | null }) {
  // Re-render every 60s so "5 min ago" stays accurate while the tab is open.
  const [, setTick] = useState(0);
  useEffect(() => {
    if (!at) return;
    const id = window.setInterval(() => setTick((t) => t + 1), 60_000);
    return () => window.clearInterval(id);
  }, [at]);

  const buildLabel = `build ${APP_VERSION}${APP_REF && APP_REF !== 'local' ? ` (${APP_REF})` : ''}`;

  if (!at) {
    return (
      <div className={styles.bar}>
        <span>Last refresh unknown — pipeline has not reported yet.</span>
        <span className={styles.abs}>· {buildLabel}</span>
      </div>
    );
  }

  return (
    <div className={styles.bar}>
      <span>Refreshed {formatRelative(at)}</span>
      <span className={styles.abs}>· {absFmt.format(new Date(at))}</span>
      <span className={styles.abs}>· {buildLabel}</span>
    </div>
  );
}
